<template>
  <div id="kioskRating" ref="clean">
    <form novalidate @submit.stop.prevent="">
      <md-list>
        <md-list-item>
          <div class="md-list-container">
            <span class="md-caption">Route geklettert? Bewerte Sie!</span>
            <div style="margin-bottom:5px;">
              <md-rating-bar @click="isLock = true" v-model="newRating.rating" class="md-accent" md-theme="orange" :md-max-rating="5"></md-rating-bar>
            </div>
          </div>
        </md-list-item>

        <md-divider style="margin-left:16px; margin-right:16px;"></md-divider>

        <md-list-item>

          <div class="md-list-container">
            <span class="md-caption">Schwierigkeit - Dein Bewertungsvorschlag</span>
            <div style="margin-top:0px; margin-bottom:10px;">

              <md-button style="margin-left:-8px;" class="md-icon-button" v-on:click.prevent="userDecrement">
                <md-icon class="md-primary" style="font-size:32px;">remove_circle</md-icon>
              </md-button>
              <div style="text-align:center; padding-top:10px; display:inline-block; padding-left:10px; margin:auto; width:50px;" class="md-title">{{ slideRange | gradeFilter }}</div>
              <md-button class="md-icon-button" v-on:click.prevent="userIncrement">
                <md-icon class="md-primary" style="font-size:32px;">add_circle</md-icon>
              </md-button>

            </div>
          </div>
        </md-list-item>

        <md-divider style="margin-left:16px; margin-right:16px;"></md-divider>

        <md-list-item>
            <div>
              <span class="md-caption">Charakter der Route (mehrere möglich)</span>
                <table style="font-size:smaller;">
                <tr style="max-height:32px; display:flex;">
                  <td style="width:140px;">
                  <md-checkbox md-value="strength" v-model="optionAttributes" class="md-primary">Kräftig</md-checkbox>
                  </td>
                  <td>
                  <md-checkbox md-value="long reach" v-model="optionAttributes" class="md-primary">Längenzüge</md-checkbox>
                  </td>
                </tr>
                <tr style="max-height:42px; display:flex;">
                  <td style="width:140px;">
                    <md-checkbox md-value="pumped forearms" v-model="optionAttributes" class="md-primary">Pumpig</md-checkbox>
                  </td>
                  <td>
                    <md-checkbox md-value="technical" v-model="optionAttributes" class="md-primary">Technisch</md-checkbox>
                  </td>
              </tr>
            </table>
            </div>
        </md-list-item>

        <md-divider style="margin-left:16px; margin-right:16px;"></md-divider>

        <div style="padding-bottom:4px; padding-top:4px; text-align:right; padding-right:16px;">
          <router-link v-if="!onceButton" @click.native="addLog()" style="color:#ffffff !important;" tag="md-button"
                      class="md-raised md-accent md-dense" event="click" to="">Route als Gast Bewerten
          </router-link>
          <router-link v-else tag="md-button" disabled
                      class="md-raised md-accent md-dense" event="click" to="">Route als Gast Bewerten
          </router-link>
        </div>
        <md-list-item>
          <md-icon style="margin-right:12px; color:#c51162">info</md-icon>
          <span style="line-height:14px; font-size:11px;">Wenn Du die Route in Deinem Routenbuch speichern möchtest, scanne statt dessen den QR-Code rechts in den Routendetails.
          </span>
        </md-list-item>

      </md-list>

    </form>

    <md-dialog-alert
      :md-title="active.routeName"
      :md-content-html="alert2.contentHtml"
      @open="onOpen"
      @close="onClose"
      ref="dialog4">
    </md-dialog-alert>

    <md-dialog-alert
      :md-title="active.routeName"
      md-content-html="Bitte fülle alle Felder aus, um einen Routenbuch Eintrag zu speichern."
      @open="onOpen"
      @close="onClose"
      ref="dialog5">
    </md-dialog-alert>

  </div>

</template>

<script>

import { mapState } from 'vuex'
import { mapMutations } from 'vuex'

import Datepicker from 'vuejs-datepicker'
import {de, en} from 'vuejs-datepicker/dist/locale'

export default {
  name: 'kioskRating',
  components: {
    Datepicker
  },

  data () {
    return {
      resetting: false,
      checkbox: true,
      isLock: false,
      newLog: {
        routeName: '',
        grade: '',
        gradeNo: '',
        userGrade: '',
        climbed: true,
        style: '',
        skills: [],
        dateCreated: '',
        comment: '',
        nonpublicComment:''
      },

      format: 'dd.MM.yyyy',
      monday: true,
      de: de,

      newRatingStatement: '',
      deleteProjectLink: '',

      options: [],
      optionAttributes: [],

      obj: '',

      alert2: {
        title: 'Error!',
        contentHtml: 'Bitte bewerte die Route.'
      },

      onceButton: false,

      logDate: new Date(),
      pageTitle: 'Route geklettert',
      newRating: {
        comment: '',
        grade: '',
        rating: 0,
        attributes: [],
        date: {
          year: '',
          month: '',
          day: ''
        }
      },

      userLogs: []
    }
  },

  created () {
    var slide = (this.active.gradeNo * 3).toFixed(0)
    this.changeSlideRange(slide)
  },

  mounted () {
    this.clearLog()
  },

  computed: {
    ...mapState([
      'validUser',
      'sectorDetails',
      'userPrivileges',
      'isSidebar',
      'active',
      'isRating',
      'slideRange',
      'userRating',
      'publicComment',
      'userAttributes',
      'projectsId',
      'isQRcode'
    ]),

    sectorId () {
      return this.$store.state.sectorDetails.id
    }
  },

  methods: {
    ...mapMutations([
      'userIncrement',
      'userDecrement',
      'changeSidebar',
      'changeTab',
      'changeActive',
      'changeSlideRange',
      'changeMarkOpen',
      'changeRateOpen',
      'changePageLoading'
    ]),

    sreset () {
      this.resetting = true
      setTimeout(() => {
        this.resetting = false
      }, 100)
    },

    openDialog (ref) {
      console.log('something')
      this.$refs[ref].open()
    },

    closeDialog (ref) {
      this.$refs[ref].close()
    },

    onOpen () {
    //  console.log('Opened')
    },

    onClose (type) {
      this.onceButton = false
    //  console.log('Closed', type)
    },

    addLog (event) {
      this.onceButton = true

      this.newRatingStatement = this.$store.state.active.links.newRatingStatement
      this.newLog.dateCreated = this.logDate.toLocaleDateString()
      this.newLog.routeName = this.active.routeName
      this.newLog.grade = this.active.grade
      this.newLog.userGrade = this.$options.filters.gradeFilter(this.slideRange)
      this.newLog.userGrade = this.newLog.userGrade.toString()

      this.newRating.comment = this.newLog.publicComment
      this.newRating.grade = this.newLog.userGrade.toString()
      this.newRating.attributes = this.optionAttributes
      this.newRating.date.day = this.logDate.getDate()
      this.newRating.date.month = this.logDate.getMonth()
      this.newRating.date.year = this.logDate.getFullYear()

      if (this.newRating.rating <= 0) {
        this.openDialog('dialog4')

      } else {
        // this.changeMarkOpen(false)
        this.addRating()
      }
    },

    addRating () {
      var ratingLog = JSON.stringify(this.newRating)
      this.changePageLoading(true)
      this.changeMarkOpen(true)
      this.changeRateOpen(false)
        this.$http.post(this.newRatingStatement + '/create', ratingLog)
          .then((response) => {
            // console.log('success new rating')
            this.$http.get(this.active.links.route)

            .then(function (response) {
              this.$store.dispatch('refreshList', this.sectorDetails.links.routes)
              this.$store.dispatch('getRouteStatements', this.active.links.route)

              this.changeActive(response.data)
              this.changePageLoading(false)
            })
            this.clearLog()
          },
        (response) => {
          alert('Guest rating not success ')
          window.location.href = '/'
          ratingLog = ''
          this.newRating.rating = 0
        })
    },

    clearLog () {
      this.logDate = new Date()
      this.newRating.rating = 0
      this.obj = ''
      this.newLog = {
        routeName: '',
        grade: '',
        gradeNo: '',
        climbed: true,
        style: '',
        skills: [],
        dateCreated: new Date(),
        dateRemoved: '',
        nonpublicComment:'',
      }

      this.optionAttributes = []
      this.onceButton = false
      this.sreset()
    },
  }
}

</script>

<style>

  .md-input-placeholder {
    color:#00838f !important;
  }

  #routeclimbed .md-list-item .md-button-ghost{
    top:inherit !important;
  }

  #routeclimbed .md-checkbox, #routeclimbed .md-radio {
    margin: 8px 8px 8px 0px;
  }

</style>
